export const areChatsEqual = (chat1, chat2) => {
  if (!chat1 || !chat2) return false;

  return chat1.sender === chat2.sender && chat1.fromMsg === chat2.fromMsg;
};

const TICKET_METADATA_FIELDS = [
  'id',
  'sender',
  'fromMsg',
  'ambiente',
  'status',
  'usuario_id',
  'setor_id',
  'nome_setor',
  'currentSectorRestricted',
  'canViewInWaitingQueue',
];

export const isSameTicket = (chat, ticket) => (
  areChatsEqual(chat, ticket)
  || (chat?.id != null && ticket?.id != null && Number(chat.id) === Number(ticket.id))
);

export const buildMessageAccessFromTicketState = (ticketState = {}) => ({
  currentSectorRestricted: ticketState.currentSectorRestricted === true,
  currentSectorName: ticketState.nome_setor || null,
});

export const shouldRefetchMessagesForTicketState = ({
  currentChat,
  previousAccess,
  ticketState,
} = {}) => (
  isSameTicket(currentChat, ticketState)
  && previousAccess?.currentSectorRestricted === true
  && ticketState?.currentSectorRestricted === false
);

export const mergeTicketMetadata = (chat, ticket) => {
  if (!chat || !ticket || !isSameTicket(chat, ticket)) return chat;

  const metadata = TICKET_METADATA_FIELDS.reduce((result, field) => {
    return ticket[field] === undefined
      ? result
      : { ...result, [field]: ticket[field] };
  }, {});

  return { ...chat, ...metadata };
};

export const updateTicketMetadataList = (chats = [], ticket) => chats.map((chat) => (
  mergeTicketMetadata(chat, ticket)
));

export const sortUserChatsByRecentMessages = (chats = []) => chats
  .slice()
  .sort(
    (chatA, chatB) => new Date(chatB.createdAt) - new Date(chatA.createdAt),
  );

export const updateUserChatsWithNewMessage = (
  chats = [],
  notification,
  currentChat,
) => {
  const isChatOpen = areChatsEqual(currentChat, notification);

  const updatedChats = chats.map((chat) => {
    if (
      chat.sender === notification.sender
      && chat.fromMsg === notification.fromMsg
    ) {
      return {
        ...chat,
        body: notification.body,
        createdAt: notification.createdAt,
        fromMe: notification.fromMe,
        mediaType: notification.mediaType,
        mediaUrl: notification.mediaUrl,
        status: notification.status ?? chat.status,
        unreadCount:
          isChatOpen || notification.fromMe === 1
            ? chat.unreadCount
            : (chat.unreadCount || 0) + 1,
        read: isChatOpen ? 1 : null,
      };
    }

    return chat;
  });

  return sortUserChatsByRecentMessages(updatedChats);
};

export const upsertChatInList = (
  chats = [],
  notification,
  currentChat,
) => {
  if (!notification?.sender || !notification?.fromMsg) {
    return chats;
  }

  const chatExists = chats.some((chat) => areChatsEqual(chat, notification));

  if (chatExists) {
    return updateUserChatsWithNewMessage(chats, notification, currentChat);
  }

  return sortUserChatsByRecentMessages([notification, ...chats]);
};

export const removeChatFromList = (chats = [], targetChat) => {
  if (!targetChat?.sender || !targetChat?.fromMsg) {
    return chats;
  }

  return chats.filter((chat) => !areChatsEqual(chat, targetChat));
};

export const updateOptimisticMessageDeliveryStatus = (
  messages = [],
  clientMessageId,
  deliveryUpdates = {},
) => {
  if (!clientMessageId) return messages;

  const definedDeliveryUpdates = {};

  Object.keys(deliveryUpdates).forEach((key) => {
    if (deliveryUpdates[key] !== undefined) {
      definedDeliveryUpdates[key] = deliveryUpdates[key];
    }
  });

  return messages.map((message) => (
    message.clientMessageId === clientMessageId
      ? {
        ...message,
        ...definedDeliveryUpdates,
      }
      : message
  ));
};
